export default __webpack_public_path__ + "static/media/security-manager-left.d840a26e.png";